import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import {formatQuerystring} from '../../../../utils/formatting';
import {getJsonFromUrl} from '../../../../utils/url';

// import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({});

class GalleryBreadcrumbs extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {

  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  goBack() {

    let pageNum = this.props.product.currentPage ? this.props.product.currentPage : 1;
    
    let urlData = getJsonFromUrl();
    if(urlData && urlData.q) {

      const pageVal = this.props.product.currentPage && this.props.product.currentPage > 1 ? `&p=${this.props.product.currentPage}` : '';

      this.internalNav('diamonds-direct-search?q=' + urlData.q + pageVal);
      return;
    }

    console.log(this.props);

    if(this.props.productType == 'diamond') {
      // // Back to non-Kayak view
      // this.internalNav('gallery/engagement-rings?view=results&mode=diamond&currentPage=' + pageNum + '&tabtype=' + this.props.productType);

      this.internalNav('gallery/engagement-rings?view=results&currentPage=' + pageNum + '&tabtype=' + this.props.productType);
    } else if(this.props.productType == 'setting') {
      // // Back to non-Kayak view
      // this.internalNav('gallery/engagement-rings?view=results&mode=setting&currentPage=' + pageNum + '&tabtype=' + this.props.productType);

      this.internalNav('gallery/engagement-rings?view=results&currentPage=' + pageNum + '&tabtype=' + this.props.productType);
    } else if(this.props.productType == 'mens') {
      this.internalNav('gallery/mens-jewelry?view=results&currentPage=' + pageNum + '&tabtype=' + this.props.productType);
    } else {

      if(this.props.product.productFilters && this.props.product.productFilters.type == 'mensband') {
        this.internalNav('gallery/wedding-bands/mens?view=results&currentPage=' + pageNum);
      } else if(this.props.product.productFilters && this.props.product.productFilters.type == 'womensband') {
        this.internalNav('gallery/wedding-bands/womens?view=results&currentPage=' + pageNum);
      } else if(this.props.product.productFilters && this.props.product.productFilters.type == 'womensband') {
        this.internalNav('gallery/wedding-bands/womens?view=results&currentPage=' + pageNum);
      } else {
        this.internalNav('gallery/fine-jewelry?' + formatQuerystring(this.props.product.productFilters) + '&currentPage=' + pageNum);
        // window.history.back();
      }
    }
  }

  disableSplashPage() {
    if(this.props.disableSplash) {
      this.props.disableSplash();
    }
  }

	render() {
		return <div className='GalleryBreadcrumbs'>
			<div className='breadcrumbsLHS'>
        {this.props.showingSplashPage ? 
          <div className='breadcrumbWrapper'>
            <div className={'breadcrumbElement splashBreadcrumbElement currentElement'}>&nbsp;</div>
            <div className={'breadcrumbElement splashBreadcrumbElement clickableElement desktopView'} onClick={::this.disableSplashPage}>Back to Results</div>
            <div className={'breadcrumbElement splashBreadcrumbElement clickableElement mobileView'} onClick={::this.disableSplashPage}>Results</div>
          </div> :
          <div className='breadcrumbWrapper'>
            <div className={'breadcrumbElement productBreadcrumbElement currentElement'}>&nbsp;</div>
            <div className={'breadcrumbElement productBreadcrumbElement clickableElement desktopView'} onClick={::this.goBack}>Back to Results</div>
            <div className={'breadcrumbElement productBreadcrumbElement clickableElement mobileView'} onClick={::this.goBack}>Back</div>
          </div>
        }
      </div>
      {!this.props.hideResultCount && false ?
        <div className='breadcrumbsRHS'>
          <div className='pageIndicator'>
            <div className='pageInnerElement'>Showing 1 - 12 of 127</div>
          </div>
          <div className='pageSizeControls'>
            <div className={'pageInnerElement selected'}>12</div>
            <div className='pageSeparationElement'>|</div>
            <div className='pageInnerElement'>24</div>
            <div className='pageSeparationElement'>|</div>
            <div className='pageInnerElement'>All</div>
          </div>
        </div> :
        null
      }
		</div>;
	}
}
export default GalleryBreadcrumbs;

function mapStateToProps(state) {
  return {
    product: state.product,
  };
}

export const GalleryBreadcrumbsContainer = connect(
  mapStateToProps,
  allActionCreators
)(GalleryBreadcrumbs);


// WEBPACK FOOTER //
// ./src/components/views/gallery/blocks/GalleryBreadcrumbs.jsx